import axios from "axios";
const basePath = process.env.VUE_APP_HZMB_GH_BASE_PATH;

/**
 * @function 准入
 * @param {*} serviceType 服務類型
 * @param {*} identNo 證件編號
 * @param {*} identType 證件類型
 * @param {*} registrationNo 車輛註冊編號
 * @param {*} plateNo 車輛號碼
 * @param {*} identificationNo 車身編號
 * @param {*} spNo 登記類型、登記編號
 * @returns
 */
export async function check({
  spNo,
  serviceType,
  registrationNo,
  plateNo,
  identificationNo,
}) {
  const { data } = await axios({
    method: "post",
    url: `${basePath}/protected/api/v1/application/hzmbH/${serviceType}`,
    params: {
      registrationNo,
      plateNo,
      identificationNo,
      spNo,
    },
  });

  return data;
}

/**
 * @function 獲取信息
 * @param {*} serviceType 服務類型
 * @param {*} registrationNo 車輛註冊編號
 * @param {*} identificationNo 車身編號
 * @returns
 */
export async function getDetail({
  serviceType,
  registrationNo,
  identificationNo,
  vehicleType,
}) {
  const { data } = await axios({
    method: "get",
    url: `${basePath}/protected/api/v1/application/hzmbH/detail`,
    params: {
      serviceType,
      registrationNo,
      identificationNo,
      vehicleType,
    },
  });

  return data;
}

/**
 * @function 暫存申請信息
 * @description 首次申請
 * @returns
 */
export async function saveFrist({ serviceType, id, vehicle, owner, drivers }) {
  const { data } = await axios({
    method: "post",
    url: `${basePath}/protected/api/v1/application/hzmbH/save/first`,
    params: {
      serviceType,
    },
    data: {
      id,
      vehicle,
      owner,
      drivers,
    },
  });

  return data;
}

/**
 * @function 暫存申請信息
 * @description 補交申請
 * @returns
 */
export async function saveFollowing({
  applicationId,
  mainlandInsuranceNo,
  mainlandInsuranceStartDate,
  mainlandInsuranceEndDate,
}) {
  const { data } = await axios({
    method: "put",
    url: `${basePath}/protected/api/v1/application/hzmbH/save/first/following`,
    params: {
      applicationId,
      mainlandInsuranceNo,
      mainlandInsuranceStartDate,
      mainlandInsuranceEndDate,
    },
  });

  return data;
}

/**
 * @function 暫存文件
 * @description 首次申請
 * @param {*} applicationId
 * @param {*} file
 * @param {*} fileValue
 * @returns
 */
export async function saveFileFrist(applicationId, file, fileValue) {
  let formData = new FormData();
  formData.append("file", file);
  formData.append(
    "fileValue",
    new Blob([JSON.stringify(fileValue)], {
      type: "application/json",
    })
  );

  const { data } = await axios({
    method: "post",
    url: `${basePath}/protected/api/v1/application/hzmbH/file/${applicationId}`,
    data: formData,
  });

  return data;
}

/**
 * @function 暫存文件
 * @description 補交申請
 * @param {*} applicationId
 * @param {*} file
 * @param {*} fileValue
 * @returns
 */
export async function saveFileFollowing(
  serviceType,
  applicationId,
  file,
  fileValue
) {
  let formData = new FormData();
  formData.append("file", file);
  formData.append(
    "fileValue",
    new Blob([JSON.stringify(fileValue)], {
      type: "application/json",
    })
  );

  const { data } = await axios({
    method: "post",
    url: `${basePath}/protected/api/v1/application/hzmbH/supplement/file/${serviceType}/${applicationId}`,
    data: formData,
  });

  return data;
}

export async function deleteFile(applicationId, fileId) {
  const { data } = await axios({
    method: "delete",
    url: `${basePath}/protected/api/v1/application/hzmbH/delete/file/${applicationId}/${fileId}`,
  });

  return data;
}

export async function downloadFile(applicationId, fileId) {
  const { data } = await axios({
    method: "get",
    url: `${basePath}/protected/api/v1/application/hzmbH/download/file/${applicationId}/${fileId}`,
    responseType: "blob",
  });

  return data;
}

export async function submit({ serviceType, id, cancelReason }) {
  const { data } = await axios({
    method: "post",
    url: `${basePath}/protected/api/v1/application/hzmbH/submit/${serviceType}/${id}`,
    headers: {
      "Content-Type": "application/json",
    },
    data: cancelReason,
  });

  return data;
}
